export default function Toggle({ label, description, checked, onChange }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "16px 20px",
        backgroundColor: checked ? "rgba(196, 93, 62, 0.05)" : "#fdfbf7",
        borderRadius: "12px",
        border: `2px solid ${checked ? "rgba(196, 93, 62, 0.2)" : "#e8e0d4"}`,
        cursor: "pointer",
        transition: "all 0.2s ease",
      }}
      onClick={onChange}
    >
      <div>
        <div
          style={{
            fontSize: "15px",
            fontWeight: 600,
            color: "#2d2418",
            fontFamily: "'DM Sans', sans-serif",
          }}
        >
          {label}
        </div>
        {description && (
          <div
            style={{
              fontSize: "13px",
              color: "#8a7e70",
              marginTop: "2px",
              fontFamily: "'DM Sans', sans-serif",
            }}
          >
            {description}
          </div>
        )}
      </div>
      <div
        style={{
          width: "48px",
          height: "28px",
          backgroundColor: checked ? "#c45d3e" : "#d4cdc0",
          borderRadius: "14px",
          position: "relative",
          transition: "all 0.3s ease",
          flexShrink: 0,
          marginLeft: "16px",
        }}
      >
        <div
          style={{
            width: "22px",
            height: "22px",
            backgroundColor: "#fff",
            borderRadius: "50%",
            position: "absolute",
            top: "3px",
            left: checked ? "23px" : "3px",
            transition: "all 0.3s ease",
            boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
          }}
        />
      </div>
    </div>
  );
}
